<template>
  <div id="app">
    <mapPane></mapPane>
    <search></search>
    <mobileToolsBar></mobileToolsBar>
    <div v-if="!isMobile" id="left-container">
      <div class="layers">
        <layerSelector></layerSelector>
        <editor-console v-if="showConsole"></editor-console>
      </div>
      <annotations v-show="this.$parent.loaded"></annotations>
    </div>
    <div v-if="isMobile" class="mobile-layers">
      <layerSelector></layerSelector>
      <editor-console v-if="layerSelectorActive && showConsole"></editor-console>
    </div>
    <annotations v-if="isMobile" v-show="this.$parent.loaded"></annotations>
    <!-- Hide until language is first loaded, to avoid showing i18n placeholders -->
    <!-- Using v-show instead of v-if to optimize image loading -->
    <banner v-show="this.$parent.loaded"></banner>
    <contextInfoModal></contextInfoModal>
    <featureInfo></featureInfo>
    <feedback></feedback>
    <KMLOverlay></KMLOverlay>
    <Logos v-if="llLogos" id="ll_logos" :logosList="llLogos"></Logos>
    <measure></measure>
    <file-drop :show="showFileDropModal" @disable="hideFileDropModal"></file-drop>
    <login-modal :show="showLoginModal" @disable="hideLoginModal"></login-modal>

    <v-dialog />

  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

import Banner from './components/Banner'
import MapPane from './components/MapPane'
import LayerSelector from './components/LayerSelector'
import ContextInfoModal from './components/ContextInfoModal'
import FeatureInfo from './components/FeatureInfo'
import Feedback from './components/Feedback'
import KMLOverlay from './components/KMLOverlay'
import Logos from './components/Logos'
import Measure from './components/Measure'
import Search from './components/Search'
import Annotations from './components/Annotations'
import MobileToolsBar from './components/MobileToolsBar'
import FileDrop from './components/FileDrop'
import LoginModal from './components/LoginModal'
import { logos, welcomePage, printApi } from 'config'

import auth from './auth'

export default {
  name: 'app',
  components: {
    Banner,
    MapPane,
    LayerSelector,
    ContextInfoModal,
    FeatureInfo,
    Feedback,
    KMLOverlay,
    Measure,
    Logos,
    Search,
    Annotations,
    MobileToolsBar,
    FileDrop,
    LoginModal
    // EditorConsole
  },
  data() {
    return {
      user: auth.user,
      showConsole: false,
      llLogos: logos && logos.ll || null,
      resizable: true,
      adaptive: true,
      draggable: true
    }
  },
  created() {
    this.$store.dispatch('fetchLayersConfig')
    if (this.user.authenticated) this.loadEditor()

    this.$store.commit('set_application_mode', { mode: window.screen.width > 768 ? 'desktop' : 'mobile' })
    window.addEventListener('resize', this.resizeHandler)
    this.$store.commit('set_enable_print', { enable: printApi && !!printApi.url })
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  watch: {
    'user.authenticated'() {
      if (this.user.authenticated) this.loadEditor()
      else this.showConsole = false
    }
  },
  mounted() {
    if (welcomePage) {
      this.showWelcomePage(true, true, true)
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.appMode === 'mobile',
      showLoginModal: state => state.showLoginModal
    }),
    ...mapGetters([
      'showFileDropModal',
      'layerSelectorActive'
    ])
  },
  methods: {
    resizeHandler() {
      this.$store.commit('set_application_mode', { mode: window.screen.width > 768 ? 'desktop' : 'mobile' })
    },
    loadEditor() {
      require.ensure(['./components/edit/EditorConsole'], require => {
        Vue.component('EditorConsole', require('./components/edit/EditorConsole'))
        this.showConsole = true
      }, 'editing-chunk')
    },

    showWelcomePage(resizable, adaptive, draggable) {
      this.resizable = resizable
      this.adaptive = adaptive
      this.draggable = draggable
      /*
        $nextTick is required because the data model with new
        "resizable, adaptive, draggable" values is not updated yet.. eh
      */
      this.$nextTick(() => {
        this.$modal.show({
          template: `
            <div class="iframe-modal-content">
              <div>Welcome</div>
              <iframe v-bind:src="iframesrc" width=100% height=100%><b>Welcome to Gonini.org!</b></iframe>
            </div>
          `,
          props: ['iframesrc']
        }, {
          iframesrc: welcomePage
        }, {
          transition: 'nice-modal-fade',
          draggable: draggable,
          adaptive: adaptive,
          resizable: resizable,
          width: 0.9 * document.body.clientWidth,
          height: 0.7 * document.body.clientHeight,
          maxWidth: 710,
          maxHeight: 850
        })
      })
    },

    hideFileDropModal() {
      this.$store.commit('show_file_drop_modal', { show: false })
    },

    hideLoginModal() {
      this.$store.commit('show_login_modal', { show: false })
    }
  }
}
</script>

<style lang="scss">
@import "./assets/global.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
html {
  height: 100%;
}
body {
  /* min-height: 100%; */
  height: 100%;
  overflow: hidden;
  background: url(assets/page-background.jpg) repeat 0 0;
}
.layers {
  overflow: hidden;
  pointer-events: none;
  align-self: stretch;
}
.mobile-layers {
  position: absolute;
  top: $banner-height + 16px;
  left: 54px;
}
#ll_logos {
  position: absolute;
  bottom: 10px;
  left: 0px;
}
.iframe-modal-content{
  height: 100%;
}
@media screen and (min-width: 769px) {
  #left-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    position: absolute;
    left: 8px;
    bottom: 65px;
    top: $banner-height + 8px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?05cd8050